<template>
    <div class="web chat">
        <div class="chatTitle" v-if="ResponseRate !== '0.01' && ResponseRate && port === 'teacher'">您最近90天的消息回复率为{{ResponseRate}}%，提高回复率才能让园长更好找到你哦！</div>
        <div class="chatTitle" v-if="ResponseRate !== '0.01' && ResponseRate && port === 'boss'">您最近90天的消息回复率为{{ResponseRate}}%，提高回复率才能让更多幼师看到你哦！</div>
        <el-row :gutter="0">
            <el-col :span="6" class="posi">
                <div class="listTitle">联系人</div>
                <div class="list" v-if="port === 'teacher'">
                    <div class="listBox" :class="item.active?'listActive':''" v-for="(item, index) in list" :key="index" @click="goChat(item)">
                        <div class="listContent">
                            <div class="listAvatar">
                                <el-avatar fit="scale-down" :size="46" :src="item.avatar" />
                                <el-badge is-dot class="item" style="vertical-align: top;" v-if="item.is_read === 0"></el-badge>
                            </div>
                            <div>
                                <div class='realname'>{{item.realname}}</div>
                                <div class="school_name">{{item.school_name}}</div>
                            </div>
                        </div>
                        <div class="send_data">
                            <div>{{item.send_Date}}</div>
                            <div class="is_read" :class="item.other_party_is_read === 0?'is_readRed':''" v-if="item.other_party_is_read !== -1">{{item.other_party_is_read === 1?'对方已读':'对方未读'}}</div>
                        </div>
                    </div>
                </div>
                <div class="list" v-if="port === 'boss'">
                    <div class="listBox" :class="item.active?'listActive':''" v-for="(item, index) in list" :key="index" @click="goChat(item)">
                        <div class="listContent">
                            <div class="listAvatar">
                                <el-avatar fit="scale-down" :size="46" :src="item.avatar" />
                                <el-badge is-dot class="item" style="vertical-align: top;" v-if="item.is_read === 0"></el-badge>
                            </div>
                            <div>
                                <div class='realname'>{{item.vita_name}}</div>
                            </div>
                        </div>
                        <div class="send_data">
                            <div>{{item.send_Date}}</div>
                            <div class="is_read" :class="item.other_party_is_read === 0?'is_readRed':''" v-if="item.other_party_is_read !== -1">{{item.other_party_is_read === 1?'对方已读':'对方未读'}}</div>
                        </div>
                    </div>
                </div>
                <page :total="total" @getList="getList" :pageSize="pageForm.size" class="posiPage" />
            </el-col>
            <el-col :span="18">
                <chatDetail :jid="jid" v-if="jid" :avatar="avatar" />
                <chatDetail :vid="vid" v-if="vid" :avatar="avatar" />
                <div class="noChatDetail" v-if="!jid && port === 'teacher'">
                    <div class="noChatDetailTop"></div>
                    <div class="noChatDetailBox">
                        <div>
                            <img src="../../assets/noData.png" alt="" />
                        </div>
                        Tips：<span>与您进行过沟通的&nbsp;{{port === 'teacher'?'园长':'幼师'}}&nbsp;都会在左侧列表中显示</span>
                    </div>
                </div>
                <div class="noChatDetail" v-if="!vid && port === 'boss'">
                    <div class="noChatDetailTop"></div>
                    <div class="noChatDetailBox">
                        <div>
                            <img src="../../assets/noData.png" alt="" />
                        </div>
                        Tips：<span>与您进行过沟通的&nbsp;{{port === 'teacher'?'园长':'幼师'}}&nbsp;都会在左侧列表中显示</span>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import page from "@/components/page";
    import noData from "@/components/noData";
    import chatDetail from './chatDetail'
    import { toTime } from '@/js/common.js'

    export default {
        components: {
            page,
            chatDetail,
            noData
        },
        data() {
            return {
                list: [],
                port: 'teacher',
                pageForm: {
                    page: 1,
                    size: 7,
                },
                total: 0,
                ResponseRate: '',
                jid: 0,
                vid: 0,
                avatar: ''
            }
        },
        created() {
            this.port = sessionStorage.getItem('port')
            this.getList()
            if(this.$route.query.vid) this.vid = this.$route.query.vid
            if(this.$route.query.jid) this.jid = this.$route.query.jid
        },
        methods: {

            // 请求消息列表
            getList(page) {
                if(page) {
                    this.pageForm.page = page
                }
                let url = this.port === 'teacher'?'/60a87105b04fb':'/60a8712610dd3'
                this.api.post(url, this.pageForm).then(r=>{
                    this.total = r.data.count
                    this.ResponseRate = this.port === 'teacher'?r.data.other.vita_chat_reply_rate:r.data.other.school_user_chat_reply_rate
                    this.list = r.data.list
                    this.list.forEach(o=>{
                        o.send_Date = toTime(o.send_time*1000, 'MM月dd日')
                        o.active = false
                    })
                })
            },

            // 去聊天
            goChat(e) {
                console.log(e)
                if(e.jid) this.jid = e.jid
                if(e.vid) this.vid = e.vid
                if(e.avatar) this.avatar = e.avatar
                this.list.forEach(o=>{
                    o.active = false
                })
                e.active = true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .chat {
        padding-top: 32px;
        .listTitle {
            line-height: 44px;
            padding-left: 22px;
            height: 46px;
            color: #9fa3b0;
            border-bottom: 2px solid #f2f2f5;
            background-color: #fbfbfc;
            white-space: nowrap;
            font-size: 14px;
            border-right: 2px solid #f2f2f5;
        }
        .list {
            background: white;
            height: calc(100vh - 159px);
            border-right: 2px solid #f2f2f5;
            .listActive {
                background-color: #f2f5fa;
            }
            .listBox {
                padding: 15px 20px 15px 30px;
                cursor: pointer;
                position: relative;
                .send_data {
                    position: absolute;
                    right: 20px;
                    top: 22px;
                    color: #9fa3b0;
                    font-size: 12px;
                }
                .listContent {
                    width: 90%;
                    >div {
                        display: inline-block;
                        vertical-align: middle;
                    }
                    .listAvatar {
                        margin-right: 10px;
                    }
                    .realname {
                        font-size: 14px;
                        color: #414a60;
                    }
                    .school_name {
                        color: #9fa3b0;
                        font-size: 12px;
                        margin-top: 3px;
                        max-width: 150px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
            .listBox:hover {
                background-color: #f2f5fa;
            }
        }
    }
    .chatTitle {
        background: #7aa8f3;
        color: #fff;
        height: 30px;
        line-height: 30px;
        padding: 0 5px;
        font-size: 12px;
    }
    .noChatDetailTop {
        line-height: 44px;
        height: 46px;
        padding-left: 22px;
        color: #9fa3b0;
        border-bottom: 2px solid #f2f2f5;
        background-color: #fbfbfc;
        white-space: nowrap;
    }
    .noChatDetailBox {
        height: calc(100vh - 159px);
        text-align: center;
        background: white;
        font-size: 13px;
        img {
            width: 20%;
            padding-top: 30%;
        }
        span {
            color: #9fa3b0;
        }
    }
    .is_read {
        padding-top: 3px;
    }
    .is_readRed {
        color: red;
    }

    .posi {
        position: relative;
        .posiPage {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 93%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/chat/index.vue